import JobsContainer from './JobsContainer';

export { GET_SAVED_JOBS, GET_APPLIED_JOBS } from './queries.graphql';
export default JobsContainer;
